import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';

import injectTapEventPlugin from 'react-tap-event-plugin';
injectTapEventPlugin();

import Game from './components/game';

window.AUDIOENABLED = true;

const el = document.getElementById('app');

ReactDOM.render(Game({ game: window.game }), el);